<template>
  <div>
    <el-card shadow="always">
      <el-page-header
        title="Home"
        @back="$router.push('/home').catch(() => {})"
        :content="$t('cadastro-atendimento')"
      ></el-page-header>
    </el-card>
    <br />
    <el-card>
      <el-row type="flex" justify="end">
        <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
          <el-input :placeholder="$t('pesquisar')" prefix-icon="el-icon-search" v-model="filter"></el-input>
        </el-col>
        <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
          <el-button
            class="right"
            type="primary"
            icon="el-icon-plus"
            @click="add()"
          >{{ $t('adicionar') }}</el-button>
        </el-col>
      </el-row>
      <el-table
        :data="tableData.filter(data => !filter || data.name.toLowerCase().includes(filter.toLowerCase()) || data.code.toLowerCase().includes(filter.toLowerCase()))"
        stripe
        style="width: 100%"
        :default-sort="{prop: 'name', order: 'ascending'}"
      >
        <el-table-column sortable prop="code" :label="$t('codigo')"></el-table-column>
        <el-table-column sortable prop="name" :label="$t('descricao')"></el-table-column>
        <el-table-column sortable prop="name" :label="$t('cliente')"></el-table-column>
        <el-table-column label="#" width="180">
          <template slot-scope="scope">
            <el-button type="info" icon="el-icon-edit" @click="editar(scope.row.id)" circle></el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              @click="remove(scope.row.id, scope.row.name)"
              circle
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
import { CallCenterService } from "@/services/customers/call.center.services";
import { i18n } from "@/plugin/i18n";

export default {
  name: "Packing",
  methods: {
    fetchRecords() {
      const vm = this;
      const loading = vm.$loading({
        lock: true,
        text: i18n.tc("carregando"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      CallCenterService.list()
        .then((response) => {
          vm.tableData = response.records;
        })
        .catch((error) => {
          vm.$notify.error({
            title: i18n.tc("erro"),
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    add() {
      this.$router.replace({ name: "call.center.add" });
    },
    editar: function (id) {
      this.$router.replace({
        name: "call.center.edit",
        params: { id: id },
      });
    },
    remove: function (id, name) {
      const vm = this;
      this.$confirm(
        i18n.t("confirmar-eliminacao-atendimento", { id: name }),
        i18n.tc("aviso"),
        {
          confirmButtonText: "OK",
          cancelButtonText: i18n.tc("cancelar"),
          type: i18n.tc("aviso"),
          center: true,
        }
      ).then(() => {
        const loading = vm.$loading({
          lock: true,
          text: i18n.tc("carregando"),
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        CallCenterService.delete(id)
          .then((response) => {
            setTimeout(() => {
              vm.fetchRecords();
            }, 300);
            this.$message({
              type: "success",
              message: i18n.tc("atendimento-eliminado-sucesso"),
            });
          })
          .catch((error) => {
            vm.$notify.error({
              title: i18n.tc("erro"),
              message: error,
            });
          })
          .finally(() => loading.close());
      });
    },
  },
  mounted() {
    const vm = this;
    vm.fetchRecords();
  },
  data() {
    return {
      filter: "",
      tableData: [],
    };
  },
};
</script>
<style>
.right {
  float: right;
}
</style>